import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IShareTestStrings extends LocalizedStringsMethods {
    lsShareTestInfoTxt: string;
    lsShareTestInfoTxt2: string;
    lsShareTestTxt: string;
    lsFNamePalceholderTxt: string;
    lsLNamePalceholderTxt: string;
    lsEmailPalceholderTxt: string;
    lsPhonePalceholderTxt: string;
    lsReEnterPalceholderEmailTxt: string;
    lsFNameTxt: string;
    lsLNameTxt: string;
    lsEmailTxt: string;
    lsActionTxt: string;
    lsDeleteTxt: string;
    lsAddTxt: string;
    lsUserInputError: string;
}

let strings: IShareTestStrings;
export default strings = new LocalizedStrings({
    en: {
        lsShareTestInfoTxt: 'Tests will be shared with the below listed users:',
        lsShareTestInfoTxt2: 'Enter recipient information below and add to send tests.\
         You may send to multiple recipients.',
        lsShareTestTxt: 'Share Tests',
        lsFNamePalceholderTxt: 'Enter First Name',
        lsLNamePalceholderTxt: 'Enter Last Name',
        lsEmailPalceholderTxt: 'Enter email',
        lsPhonePalceholderTxt: 'Enter phone',
        lsReEnterPalceholderEmailTxt: 'Re-enter email',
        lsFNameTxt: 'First Name',
        lsLNameTxt: 'Last Name',
        lsEmailTxt: 'Email',
        lsActionTxt: 'Action',
        lsDeleteTxt: 'Delete',
        lsAddTxt: 'Add',
        lsUserInputError: 'Cannot add duplicate user information for share'
    },
    es: {
        lsShareTestInfoTxt: 'Las pruebas se compartirán con los usuarios enumerados a continuación:',
        lsShareTestInfoTxt2: 'Ingrese la información del destinatario a continuación \
        y agréguelo para enviar las pruebas.\
        Puede enviar a múltiples destinatarios.',
        lsShareTestTxt: 'Compartir pruebas',
        lsFNamePalceholderTxt: 'Ingresa el nombre',
        lsLNamePalceholderTxt: 'Introduzca el apellido',
        lsEmailPalceholderTxt: 'Ingrese correo electrónico',
        lsPhonePalceholderTxt: 'Enter phone',
        lsReEnterPalceholderEmailTxt: 'Volver a introducir correo electrónico',
        lsFNameTxt: 'Nombre de pila',
        lsLNameTxt: 'Apellido',
        lsEmailTxt: 'Email',
        lsActionTxt: 'Acción',
        lsDeleteTxt: 'Borrar',
        lsAddTxt: 'Añadir',
        lsUserInputError: 'Cannot add duplicate user information for share'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/test/string.test.share.tsx